import React from 'react'
import { useRouter } from 'next/router'

import KinerjaKSPerencanaanApp from 'app/KinerjaKSPage/pages/Perencanaan'
import KinerjaDemoLayout from 'app/KinerjaPage/components/KinerjaDemoLayout'
import { useAPIKinerja } from 'api/kinerja/useAPIKinerjaKS'
import { InvalidUserUnauthorized } from 'api/kinerja/useAPIKinerja'
import ContentProvider from 'app/KinerjaKSPage/components/ContentProvider'
import { SchoolProvider } from 'app/KinerjaKSPage/components/SchoolContentProvider'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'

import type { Jenjang } from 'types/kinerja'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabled = toggle?.['kinerja-ks-enabled'] ?? false

    // TODO: replace with proper toggle in the next
    //       iteration.
    const enabledDemo = process.env.NEXT_PUBLIC_ENV !== 'production'

    if (!enabled || !enabledDemo) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }
  },
})

const KinerjaDemoKSPerencanaan = ({}) => {
  const router = useRouter()
  const { isSuccess, isKsPlt, isKsDefinitif } = useRoleContext()

  const isKs = isKsPlt || isKsDefinitif

  const { data: { data: skp } = {}, isFetched: isSkpFetched } = useAPIKinerja(
    'demo',
    {
      enabled: router.isReady && isKs,
      isDemoMode: true,
    }
  )

  if (isSuccess && !isKs) {
    throw new InvalidUserUnauthorized('/', null)
  }

  return (
    <>
      <ContentProvider
        jenjang={skp?.jenjang as Jenjang}
        isSkpFetched={isSkpFetched}
      >
        <SchoolProvider>
          <KinerjaKSPerencanaanApp skp={skp} isSKPFetched={isSkpFetched} />
        </SchoolProvider>
      </ContentProvider>
    </>
  )
}

KinerjaDemoKSPerencanaan.Layout = KinerjaDemoLayout

KinerjaDemoKSPerencanaan.layoutOpts = {
  hasHeader: true,
}

export default KinerjaDemoKSPerencanaan
